module.exports = __webpack_public_path__ + "static/media/account.5f7c2ac6.svg";